/**
 * ErrorReportingBoundary wraps ErrorBoundary. It reports the error thrown
 * to the server/analytics system and then shows the Sparx Maths error screen.
 */
import { connect } from 'react-redux';

import { reportError, sparxWebError } from 'phoenix2/state/errors/actions';

import ErrorBoundary from './error-boundary.jsx';
import { CLIENT_ERROR_LEVEL_ERROR, CLIENT_ERROR_LEVEL_WARNING } from '../../state/errors/errors';

const mapStateToProps = state => ({
    alert: state.get('alert'),
});

/**
 * Parse the React error boundary info string into an array of strings, one
 * per line of the info string
 * @param info
 * @returns {*}
 */
const parseInfo = info => {
    let infoArray = info.split('\n');
    infoArray = infoArray.map(s => s.replace('\t', '').trim());
    if (infoArray.length > 0 && infoArray[0].length === 0) {
        infoArray = infoArray.slice(1);
    }
    return infoArray;
};

export const mapDispatchToProps = dispatch => ({
    handleError: (error, info, throwSparxWebError = true) => {
        let infoArray = null;
        if (info) {
            infoArray = parseInfo(info);
        }

        // If the user saw an error message, report it as an error, otherwise
        // just a warning
        const level = throwSparxWebError ? CLIENT_ERROR_LEVEL_ERROR : CLIENT_ERROR_LEVEL_WARNING;

        dispatch(reportError(error, infoArray, level));
        if (throwSparxWebError) {
            dispatch(sparxWebError());
        }
    },
});

const connectErrorReportingBoundary = connect(mapStateToProps, mapDispatchToProps);

export const ErrorReportingBoundary = connectErrorReportingBoundary(ErrorBoundary);
export default ErrorReportingBoundary;

ErrorReportingBoundary.displayName = 'ErrorReportingBoundaryContainer';
